/**
 * Place a floating panel beside an anchor point (a click): to the anchor's
 * LEFT, vertically centered on it, clamped to the viewport — and flipped to the
 * anchor's RIGHT when it wouldn't fit on the left. Shared by the chart-settings
 * modal AND the indicator / drawing-overlay settings drawers so every chart
 * popup anchors to the click identically (vs. drifting between anchored and
 * centered layouts).
 *
 * Coordinates are viewport (client) pixels — pair with `position: fixed`.
 */
export function anchoredPanelPosition(
  anchor: { x: number; y: number },
  panelWidth: number,
  panelHeight: number,
  margin = 12,
): { left: number; top: number } {
  let left = anchor.x - panelWidth - margin
  // Flip to the right of the click when the panel would spill off the left edge.
  if (left < margin) left = anchor.x + margin
  left = Math.max(margin, Math.min(left, window.innerWidth - panelWidth - margin))
  const top = Math.max(
    margin,
    Math.min(anchor.y - panelHeight / 2, window.innerHeight - panelHeight - margin),
  )
  return { left, top }
}
